import { dew as _getSchemaUtilsDew } from "./getSchemaUtils";
import { dew as _JsonErrorDew } from "./JsonError";
import { dew as _ParseErrorDew } from "./ParseError";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ParseError = exports.JsonError = exports.transform = exports.optional = exports.getSchemaUtils = void 0;
  var getSchemaUtils_1 = _getSchemaUtilsDew();
  Object.defineProperty(exports, "getSchemaUtils", {
    enumerable: true,
    get: function () {
      return getSchemaUtils_1.getSchemaUtils;
    }
  });
  Object.defineProperty(exports, "optional", {
    enumerable: true,
    get: function () {
      return getSchemaUtils_1.optional;
    }
  });
  Object.defineProperty(exports, "transform", {
    enumerable: true,
    get: function () {
      return getSchemaUtils_1.transform;
    }
  });
  var JsonError_1 = _JsonErrorDew();
  Object.defineProperty(exports, "JsonError", {
    enumerable: true,
    get: function () {
      return JsonError_1.JsonError;
    }
  });
  var ParseError_1 = _ParseErrorDew();
  Object.defineProperty(exports, "ParseError", {
    enumerable: true,
    get: function () {
      return ParseError_1.ParseError;
    }
  });
  return exports;
}